import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCourseHistoryRequest } from '../../../api/requests/curriculum';
import { useAcademicInformation } from '../../../components/careerSelector/useAcademicInformation';
import { useLoadingState } from '../../../hooks/useLoadingState';
import StudentCurriculumProgress from './StudentCurriculumProgress';

export function StudentCurriculumProgressContent() {
  const prefix = 'curricularAdvancement';
  const { selectedCareer } = useAcademicInformation();
  const [curriculumProgressAvg, setCurriculumProgressAvg] = useState<
    number | null
  >(null);

  const { t } = useTranslation();
  const { setLoading } = useLoadingState();

  const texts = useMemo(
    () => ({
      CurriculumProgressTooltip: t(`${prefix}.curriculumProgressTooltip`),
      CurriculumProgress: t(`${prefix}.curriculumProgress`),
    }),
    [t],
  );

  const getStudentCurriculumProgress = useCallback(async () => {
    const { data } = await getCourseHistoryRequest(
      selectedCareer.studyPlanEnrollmentId,
    );
    if (data) {
      setCurriculumProgressAvg(data.data.curriculumProgressAvg);
    }
    setLoading(false);
  }, [selectedCareer.studyPlanEnrollmentId, setLoading]);

  useEffect(() => {
    getStudentCurriculumProgress();
  }, [getStudentCurriculumProgress]);

  return (
    <div className="mb-3">
      <StudentCurriculumProgress
        studyPlanEnrollmentId={selectedCareer.studyPlanEnrollmentId}
        texts={texts}
        curriculumProgressAvg={curriculumProgressAvg ?? 0}
      />
    </div>
  );
}
